import styled from "@emotion/styled";
import { Typography, Grid, Divider } from "@mui/material";
import Logo from "./logo.png";
import { forwardRef } from "react";

const SectionDivider = styled(Divider)({
  backgroundColor: "black",
});

const PageHeader = forwardRef(({ leftContent, centerContent }, ref) => {
  return (
    <Grid container direction="column" ref={ref}>
      <Grid container direction="row" justifyContent="space-between">
        <Typography variant="body2">{leftContent}</Typography>
        <Typography variant="body2">{centerContent}</Typography>
        <img src={Logo} height={16} alt="logo" />
      </Grid>
      <SectionDivider />
    </Grid>
  );
});

export default PageHeader;
